import { UserDetailScreen } from "@/features/staff/users";

export default function UserDetailPage() {
  return <UserDetailScreen />;
}
